import { render } from "./VideoViewer.vue?vue&type=template&id=2bc7a75a&scoped=true"
import script from "./VideoViewer.vue?vue&type=script&lang=js"
export * from "./VideoViewer.vue?vue&type=script&lang=js"

import "./VideoViewer.vue?vue&type=style&index=0&id=2bc7a75a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc7a75a"]])

export default __exports__